import React from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Toast } from '@atlas/ui';

const NotificationPopup = props => {
  const { data, id, message, status } = props;

  const onCloseHandler = React.useCallback(() => NotificationManager.removeNotification(id), [id]);

  return (
    <Toast
      className="desktop"
      message={message}
      onClose={onCloseHandler}
      params={data}
      rawText={data?.rawText}
      type={status}
    />
  );
};

export default NotificationPopup;

NotificationPopup.propTypes = {
  data: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.string,
  status: PropTypes.string,
};
